module.exports = "/assets/data/c7a2dabb61b555f4b4730a003b542060-RG1.data.json";